import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getUserInfo } from '@/util/auth'

NProgress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  const user = getUserInfo()
  var code = to.query.code

  // hot fix anchor achived camp error qrcode
  if (code === '17E7D3C8CF249B65') {
    next({ path: '/survey-new', query: { code: '1EDC66E5AAF09974', surveykey: 'Q1593088514532' }, replace: true })
  }
  if (code === 'C8CE518E3D93641C') {
    next({ path: '/survey-new', query: { code: '8D45294147BED71C', surveykey: 'Q1593088514532' }, replace: true })
  }

  if (user.token) {
    if (to.path === '/login' || to.path === '/') {
      if (to.query.code) {
        // next()
        next({ path: '/home?active=document', query: to.query, replace: true })
      } else {
        next({ path: '/home?active=self', query: to.query, replace: true })
      }
    } else {
      next()
    }
    NProgress.done()
  } else {
    if (
      to.path !== '/404' &&
            to.path !== '/login' &&
            to.path !== '/coutryCodePane' &&
            to.path !== '/publicEvent' &&
            to.path !== '/newEvent' &&
            to.path !== '/survey' &&
            to.path !== '/simpleLogin' &&
            to.path !== '/alumniLogin' &&
            to.path !== '/reallyAlumniLogin' &&
            to.path !== '/course' &&
            to.path !== '/course/detail' &&
            to.path !== '/survey-new' &&
            to.path !== '/self-diagnosis' &&
            to.path !== '/internshipChallenge' &&
            to.path !== '/icAssistant' &&
            to.path !== '/wechat' &&
            to.path !== '/drawlots' &&
            !to.path.startsWith('/m')
    ) {
      if (to.path === '/apply' || to.path === '/ic-test' || to.fullPath === '/home?active=self') {
        next({ path: '/simpleLogin', query: { redirect: to.fullPath }, replace: true })
      } else if (to.path === '/counselling') {
        next({ path: '/alumniLogin', query: { redirect: to.fullPath }, replace: true })
      } else if (to.path === '/share' || to.path === '/pick-class') {
        next({ path: '/reallyAlumniLogin', query: { redirect: to.fullPath }, replace: true })
      } else {
        next({ path: '/login', query: to.query, replace: true })
      }
    } else {
      next()
    }
    NProgress.done()
  }
})

router.afterEach(() => {
  NProgress.done()
})
